import React, { Component, Fragment } from "react";
import CSSTransitionGroup from "react-transition-group/CSSTransitionGroup";

import { Row, Col } from "reactstrap";

import { Sparklines, SparklinesCurve } from "react-sparklines";

import { makeData } from "../../../Tables/DataTables/Examples/utils";

import CountUp from "react-countup";

function boxMullerRandom() {
  let phase = true,
    x1,
    x2,
    w;

  return (function () {
    if (phase) {
      do {
        x1 = 2.0 * Math.random() - 1.0;
        x2 = 2.0 * Math.random() - 1.0;
        w = x1 * x1 + x2 * x2;
      } while (w >= 1.0);

      w = Math.sqrt((-2.0 * Math.log(w)) / w);
      return x1 * w;
    } else {
      return x2 * w;
    }
  })();
}

function randomData(n = 1) {
  return Array.apply(0, Array(n)).map(boxMullerRandom);
}

const sampleData = randomData(1);
const sampleData2 = randomData(1);
const sampleData3 = randomData(1);
const sampleData4 = randomData(1);

const TotalScoreCards = ({ obj }) => {
  return (
    <Fragment>
      <CSSTransitionGroup
        component="div"
        transitionName="TabsAnimation"
        transitionAppear={true}
        transitionAppearTimeout={0}
        transitionEnter={false}
        transitionLeave={false}
      >
        <div>
          <Row>
            <Col lg="12" xl="12">
              <Row>
                <Col md="6" lg="3" xl="3">
                  <div className="card mb-3 mt-3 widget-chart widget-chart2 text-left card-btm-border card-shadow-success border-success">
                    <div className="widget-chat-wrapper-outer fiscalNameCard">
                      <div className="hatena">
                        ？{" "}
                        <p className="explaine">
                          自組織の全事業の合計数（下記「事業紹介と実績」に登録された最新年度の事業が反映されます）
                        </p>
                      </div>
                      <div
                        className="widget-chart-content pl-3 pb-1"
                        style={{ marginTop: 10 }}
                      >
                        <h6 className="widget-heading mb-0">事業数</h6>
                        <div className="widget-chart-flex">
                          <div className="widget-numbers">
                            <div className="widget-chart-flex">
                              <div
                                className="fsize-4"
                                style={{ marginTop: -10, fontWeight: "bold" }}
                              >
                                <CountUp
                                  start={0}
                                  end={obj.totalBusinesses}
                                  separator=","
                                  decimals={0}
                                  decimal=""
                                  prefix=""
                                  duration="1"
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      {/* <Row className="no-gutters widget-chart-wrapper mt-3 mb-3 pl-2 he-auto">
                        <Col md="9">
                          <Sparklines data={sampleData}>
                          <SparklinesCurve
                              style={{
                                strokeWidth: 3,
                                stroke: "var(--success)",
                                fill: "none",
                              }}
                            />
                          </Sparklines>
                        </Col>
                      </Row> */}
                    </div>
                  </div>
                </Col>
                <Col md="6" lg="3" xl="3">
                  <div className="card mb-3 mt-3 widget-chart widget-chart2 text-left card-btm-border card-shadow-primary border-primary">
                    <div className="widget-chat-wrapper-outer fiscalNameCard">
                      <div className="hatena">
                        ？{" "}
                        <p className="explaine">
                          自組織の全事業の支出の合計額（下記「事業紹介と実績」に登録された最新年度の事業が反映されます）
                        </p>
                      </div>
                      <div
                        className="widget-chart-content pl-3 pb-1"
                        style={{ marginTop: 10 }}
                      >
                        <h6 className="widget-heading mb-0">事業額</h6>
                        <div className="widget-chart-flex">
                          <div className="widget-numbers">
                            <div className="widget-chart-flex">
                              <div
                                className="fsize-4"
                                style={{ marginTop: -10, fontWeight: "bold" }}
                              >
                                <CountUp
                                  start={0}
                                  end={obj.totalBusinessCost}
                                  // end={obj.totalOrdinaryRevenue}
                                  separator=","
                                  decimals={0}
                                  decimal=""
                                  prefix=""
                                  duration="1"
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      {/* <Row className="no-gutters widget-chart-wrapper mt-3 mb-3 pl-2 he-auto">
                        <Col md="9">
                          <Sparklines data={sampleData2}>
                            <SparklinesCurve
                              style={{
                                strokeWidth: 3,
                                stroke: "var(--primary)",
                                fill: "none",
                              }}
                            />
                          </Sparklines>
                        </Col>
                      </Row> */}
                    </div>
                  </div>
                </Col>
                <Col md="6" lg="3" xl="3">
                  <div className="card mb-3 mt-3 widget-chart widget-chart2 text-left card-btm-border card-shadow-warning border-warning">
                    <div className="widget-chat-wrapper-outer fiscalNameCard">
                      <div className="hatena">
                        ？{" "}
                        <p className="explaine">
                          自組織の全事業に従事する人数の合計（下記「事業紹介と実績」に登録された最新年度の事業が反映されます）
                        </p>
                      </div>
                      <div
                        className="widget-chart-content pl-3 pb-1"
                        style={{ marginTop: 10 }}
                      >
                        <h6 className="widget-heading mb-0">事業の従事者数</h6>
                        <div className="widget-chart-flex">
                          <div className="widget-numbers">
                            <div className="widget-chart-flex">
                              <div
                                className="fsize-4"
                                style={{ marginTop: -10, fontWeight: "bold" }}
                              >
                                <CountUp
                                  start={0}
                                  end={obj.totalWorkers}
                                  separator=","
                                  decimals={0}
                                  decimal=""
                                  prefix=""
                                  duration="1"
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      {/* <Row className="no-gutters widget-chart-wrapper mt-3 mb-3 pl-2 he-auto">
                        <Col md="9">
                          <Sparklines data={sampleData3}>
                            <SparklinesCurve
                              style={{
                                strokeWidth: 3,
                                stroke: "var(--warning)",
                                fill: "none",
                              }}
                            />
                          </Sparklines>
                        </Col>
                      </Row> */}
                    </div>
                  </div>
                </Col>
                <Col md="6" lg="3" xl="3">
                  <div className="card mb-3 mt-3 widget-chart widget-chart2 text-left card-btm-border card-shadow-danger border-danger">
                    <div className="widget-chat-wrapper-outer fiscalNameCard">
                      <div className="hatena">
                        ？{" "}
                        <p className="explaine">
                          自組織の全事業を通じて利益・支援を得た人（受益者）の人数の合計（下記「事業紹介と実績」に登録された最新年度の事業が反映されます）
                        </p>
                      </div>
                      <div
                        className="widget-chart-content pl-3 pb-1"
                        style={{ marginTop: 10 }}
                      >
                        <h6 className="widget-heading mb-0">事業の受益者数</h6>
                        <div className="widget-chart-flex">
                          <div className="widget-numbers">
                            <div className="widget-chart-flex">
                              <div
                                className="fsize-4"
                                style={{ marginTop: -10, fontWeight: "bold" }}
                              >
                                <CountUp
                                  start={0}
                                  end={obj.totalBeneficiaries}
                                  separator=","
                                  decimals={0}
                                  decimal=""
                                  prefix=""
                                  duration="1"
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      {/* <Row className="no-gutters widget-chart-wrapper mt-3 mb-3 pl-2 he-auto">
                        <Col md="9">
                          <Sparklines data={sampleData4}>
                            <SparklinesCurve
                              style={{
                                strokeWidth: 3,
                                stroke: "var(--danger)",
                                fill: "none",
                              }}
                            />
                          </Sparklines>
                        </Col>
                      </Row> */}
                    </div>
                  </div>
                </Col>
              </Row>
            </Col>
          </Row>
        </div>
      </CSSTransitionGroup>
    </Fragment>
  );
};

export default TotalScoreCards;
